import { Filter } from '@vrplatform/components';
import { Icon } from '@vrplatform/icons';
import type { SelectItem } from '@vrplatform/components';
import type { Maybe } from '@vrplatform/utils';
import { useMemo } from 'react';
import type { JournalEntryRelation } from '@vrplatform/ui-common';
import { useEnabledFeatures } from '@vrplatform/data';

type Props = {
  value: Maybe<string>;
  setValue: (value: Maybe<JournalEntryRelation>) => void;
};

export const JournalEntryTypeFilter = ({ setValue, value: initial }: Props) => {
  const { OPEX } = useEnabledFeatures();

  const options = useMemo(() => {
    const base: SelectItem<JournalEntryRelation>[] = [
      {
        label: 'Reservation',
        value: 'reservation',
        icon: <Icon icon="CalendarEventIcon" size={16} />,
      },
      {
        label: 'Deposit',
        value: 'deposit',
        icon: <Icon icon="PlusCircleIcon" size={16} />,
      },
      {
        label: 'Expense',
        value: 'expense',
        icon: <Icon icon="MinusCircleIcon" size={16} />,
      },
      {
        label: 'Fee & Commission',
        value: 'recurringFee',
        icon: <Icon icon="PercentageIcon" size={16} />,
      },
      {
        label: 'Payout',
        value: 'payout',
        icon: <Icon icon="CircleDollarIcon" size={16} />,
      },
    ];

    if (OPEX) {
      base.push({
        label: 'Bank transfer',
        value: 'transfer',
        icon: <Icon icon="ShuffleIcon" size={14} />,
      });
    }

    return base;
  }, [OPEX]);

  const value = options.find((i) => i.value === initial) || null;

  return (
    <Filter.Select
      value={value}
      label="Type"
      setValue={(v) => setValue(v?.value)}
      type="single"
      data={{
        options,
      }}
      hideIcon
    />
  );
};
